<template>
  <div class=" fixed-top subheader"> 
    <nav class="navbar-expand-sm navbar-dark " > 
      <div class="container-fluid d-flex justify-content-start"> 
          <div>
             <label >{{title}}</label>
          </div>
      </div>
    </nav>
  </div>
  
  
</template>
<script>
export default {
  name: "Subheader",
  props:{
   title: String
  },
  data() {
    return {
     date:'',
    };
  },
  mounted() {
  },

  methods: {
    
  },
 
};
</script>
<style>

</style>